// extracted by mini-css-extract-plugin
export default {"root":"rmIcMEgtQJvspdkhYeDm","wrap":"PghkClXuHy3TdZTiS7SI","amount":"yZYLejc9ldGy7SSEdwND","text":"iSnM23cHTRlp5tuzalrA"};